import { atom } from 'jotai'

export const selectedEventAtom = atom()
export const currentViewAtom = atom()
